module.exports = __webpack_public_path__ + "static/media/neutral_face_no_shadow.cd74ddd5.svg";